import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { Userpilot } from 'userpilot';

import packageJson from '../../../package.json';
import getEnv from '@/shared/configs/env';
import { beforeSendLogs, beforeSendRum } from './telemetry-before-send';

export const initializeMonitoring = () => {
  const env = getEnv();

  datadogLogs.init({
    version: packageJson.version,
    clientToken: env.react_app_dd_client_id,
    service: 'landlord-portal-frontend',
    env: env.app_env,
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['info', 'warn', 'error'],
    sessionSampleRate: 100,
    beforeSend: beforeSendLogs,
  });

  // Skip RUM in local `vite dev` so a developer's sessions aren't reported under a deployed env tag.
  if (!import.meta.env.DEV) {
    datadogRum.init({
      version: packageJson.version,
      site: 'datadoghq.com',
      env: env.app_env,
      applicationId: env.react_app_dd_app_id,
      clientToken: env.react_app_dd_client_id,
      service: 'landlord-portal-frontend',
      sessionSampleRate: 25,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      propagateTraceBaggage: false,
      // Keeps masked (user-input) content out of automatic action names.
      enablePrivacyForActionName: true,
      beforeSend: beforeSendRum,
      plugins: [reactPlugin({ router: true })],
      allowedTracingUrls: [
        /propertymanager\.((development|integration|staging)\.)?theguarantors\.com/,
        /deals-dashboard\.((development|integration|staging)\.)?theguarantors\.com/,
        /claims-portal\.((development|integration|staging)\.)?theguarantors\.com/,
        /landlord-portal-backend\.((development|integration|staging)\.)?theguarantors\.com/,
      ],
    });
  }

  const userpilotKey =
    globalThis.location.hostname === 'propertymanager.theguarantors.com'
      ? env.userpilot_api_key.replace('STG-', '')
      : env.userpilot_api_key;
  Userpilot.initialize(userpilotKey);
};
